const faTriangle = {
  prefix: 'fal',
  iconName: 'triangle',
  icon: [
    512,
    512,
    [9650],
    'f2ec',
    'M256.5 0c14.7 0 28.2 8.1 35.2 21l216 400c6.7 12.4 6.4 27.4-.8 39.5S486.6 480 472.5 480l-432 0c-14.1 0-27.1-7.4-34.3-19.5s-7.5-27.1-.8-39.5l216-400c7-12.9 20.5-21 35.2-21zm0 32c-2.2 0-4.3 .9-5.7 2.4l-1.3 1.8-216 400c-1.3 2.5-1.3 5.5 .2 7.9l1.3 1.6c1.5 1.4 3.5 2.3 5.6 2.3l432 0c2.8 0 5.4-1.5 6.9-3.9l.8-1.9c.4-1.3 .4-2.7 .1-4.1l-.7-1.9-216-400c-1.4-2.6-4.1-4.2-7-4.2z',
  ],
};
export default faTriangle;
